import { Injectable } from '@angular/core';
import * as subscriptionManagerSelectors from '@ddt-web/blk-model-subscription-manager';
import { SelectorGeneratorService } from '@ddt-web/common';
import { ModelPortfolio } from '@ddt-web/domain';
import { WebToolsPlatformDataService } from '@ddt-web/web-tools-platform';
import { select, Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';

import { ModelPortfoliosStoreConfig, ModelPortfoliosStoreFeatureName } from './model-portfolios-store.config';

@Injectable()
export class PortfolioStoreProxyService {
	// observables
	private savedPortfolioIds$: Observable<string[]>;
	private modelPortfolios$: Observable<Array<ModelPortfolio>>;

	constructor(
		private store: Store<any>,
		private webToolsPlatformDataService: WebToolsPlatformDataService,
		private selectorGeneratorService: SelectorGeneratorService
	) {
		const selectors = this.selectorGeneratorService.getSelectors(ModelPortfoliosStoreConfig, ModelPortfoliosStoreFeatureName);

		this.modelPortfolios$ = this.store.pipe(select(selectors[ModelPortfoliosStoreConfig.modelPortfolios.name]));
		this.savedPortfolioIds$ = this.store.pipe(
			select(subscriptionManagerSelectors.getSavedModelPortfolioIdMappings),
			map(mappings => (mappings ? Array.from(mappings.keys()) : []))
		);
	}

	/**
	 * Used to load saved BLK models - used in PA.
	 */
	public loadSavedAndSubscribeModelIds(): void {
		this.webToolsPlatformDataService
			.loadSavedAndSubscribedModelIds()
			.pipe(first())
			.subscribe();
	}

	/*************************************************
	 * Getters
	 *************************************************/

	/**
	 * Used for the save/unsave BLK model functionality in PA.
	 * @returns observable of the saved models ids
	 */
	public getSavedPortfolioIds$(): Observable<string[]> {
		return this.savedPortfolioIds$;
	}
	public getModelPortfolios$(): Observable<Array<ModelPortfolio>> {
		return this.modelPortfolios$;
	}

}
